import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  AddBuildingPageLoader,
  AddBuildingPageAction,
} from "./AddBuildingPage/loaders";
import {
  BuildingDetailsPageLoader,
  BuildingDetailsPageAction,
} from "./BuildingDetailsPage/loaders";
import {
  BuildingTablePageLoader,
  buildingTableShouldRevalidate,
} from "./BuildingTablePage/loaders";

const BuildingTablePage = lazyNamedPage("BuildingTablePage", () =>
  import(
    /* webpackChunkName: "building" */
    "./BuildingTablePage/BuildingTablePage"
  ),
);
const AddBuildingPage = lazyNamedPage("AddBuildingPage", () =>
  import(
    /* webpackChunkName: "building" */
    "./AddBuildingPage/AddBuildingPage"
  ),
);
const BuildingDetailsPage = lazyNamedPage("BuildingDetailsPage", () =>
  import(
    /* webpackChunkName: "building" */
    "./BuildingDetailsPage/BuildingDetailsPage"
  ),
);

/**
 * Public routes for Building pages (accessible to unauthenticated users)
 * Returns only the table/list page route
 */
export const BuildingPagesPublicRoutes = () => {
  return (
    <Route
      path="/building"
      loader={BuildingTablePageLoader}
      shouldRevalidate={buildingTableShouldRevalidate}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<BuildingTablePage />}
    />
  );
};

/**
 * Protected routes for Building pages (require authentication)
 * Returns detail and add page routes
 */
export const BuildingPagesProtectedRoutes = () => {
  return (
    <>
      <Route
        path="/add-building"
        loader={AddBuildingPageLoader}
        action={AddBuildingPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AddBuildingPage />}
      />
      <Route
        path="/building/:buildingID"
        loader={BuildingDetailsPageLoader}
        action={BuildingDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<BuildingDetailsPage />}
      />
    </>
  );
};

/**
 * Legacy export - returns all routes (for backwards compatibility if needed)
 * @deprecated Use BuildingPagesPublicRoutes() and BuildingPagesProtectedRoutes() instead
 */
export const BuildingPagesRoutes = () => {
  return (
    <>
      {BuildingPagesPublicRoutes()}
      {BuildingPagesProtectedRoutes()}
    </>
  );
};
